/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Origins_FoundInputs */

const en_no_origins_found = /** @type {(inputs: No_Origins_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No origins found.`)
};

const es_no_origins_found = /** @type {(inputs: No_Origins_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron origenes.`)
};

/**
* | output |
* | --- |
* | "No origins found." |
*
* @param {No_Origins_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const no_origins_found = /** @type {((inputs?: No_Origins_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Origins_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_origins_found(inputs)
	return es_no_origins_found(inputs)
});